import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from '../core/services/config.service';

@Pipe({
    name: 'shortHash'
})
export class ShortHashPipe implements PipeTransform {
    transform(string: any, args?: any): any {
        if (typeof string === 'string' || string instanceof String) {
            let hash = 0;
            for (let i = 0; i < string.length; i++) {
              let chr   = string.charCodeAt(i);
              hash  = ((hash << 5) - hash) + chr;
              hash |= 0; 
            }
            if (hash < 0) {
                hash = hash * -1;
            }
            return hash.toString(16).toUpperCase();
        }
        return "";
    }

}
